module.exports = __webpack_public_path__ + "static/img/game_operator.4c12b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/game_operator.jpg
// module id = Ae+J
// module chunks = 1